<div id="uninstall-container" class="unset-height-non-fullscreen">
    <header class="red-to-purlpe-gradient">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="header-content">
                        <h1 [translate]="'uninstall.sad_to_see_you_go'"></h1>
                        <hr />
                        <h2 [translate]="'uninstall.thanks_for_using'"></h2>
                        <img height="200" src="@imagesDir/uninstall.jpg" alt="---uninstall---" title=":(" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div [hidden]="surveyAnswered">
                        <h2 [translate]="'uninstall.remove_question'"></h2>
                        <div [formGroup]="formGroup">
                            <div
                                formArrayName="reasons"
                                class="form-group"
                                *ngFor="let reason of reasons; let i = index">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        id="{{reason.value}}"
                                        [formControlName]="i"
                                        type="checkbox"
                                        class="custom-control-input" />
                                    <label for="{{reason.value}}" class="custom-control-label">{{reason.text}}</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="otherReason" [translate]="'uninstall.other_reason'"></label>
                                <textarea
                                    id="otherReason"
                                    [formControlName]="'otherReason'"
                                    class="textarea-resize-none form-control three-rows-textarea"></textarea>
                            </div>
                            <button-control
                                buttonType="button"
                                themeColor="primary"
                                [buttonText]="'common.save'"
                                (onClick)="save()">
                            </button-control>
                        </div>
                    </div>
                    <div [hidden]="!surveyAnswered">
                        <h1 [translate]="'uninstall.thanks_for_filling_survey'"></h1>
                        <hr />
                    </div>
                </div>
            </div>
        </div>
    </header>
    <section id="social" class="background-aliceblue">
        <subscribe-wecdev-control></subscribe-wecdev-control>
    </section>
</div>
<uninstall-donation-modal #uninstallDonationModal></uninstall-donation-modal>
